document.addEventListener('readystatechange', () => {
    // obtain plugin
    var cc = initCookieConsent();

    // run plugin with your configuration
    cc.run({
        current_lang: 'en',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false

        gui_options: {
            consent_modal: {
                layout: 'cloud',               // box/cloud/bar
                position: 'bottom left',     // bottom/middle/top + left/right/center
                transition: 'slide',           // zoom/slide
                swap_buttons: false            // enable to invert buttons
            },
            settings_modal: {
                layout: 'box',                 // box/bar
                // position: 'left',           // left/right
                transition: 'slide'            // zoom/slide
            }
        },

        languages: {
            'en': {
                consent_modal: {
                    title: 'About your privacy and cookies',
                    description: 'We use cookies to help make our website and services better. You consent to our use of cookies if you continue to use this website.',
                    primary_btn: {
                        text: 'Accept All',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Settings',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie Preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept All',
                    reject_all_btn: 'Reject All',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Cookie name'},
                        {col2: 'Default expiration time'},
                        {col3: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'How we use cookies',
                            description: 
                                '<div class="cookie__container"><p>Cookies are small files that our websites place on your computer to help make it easier to use.</p> <div class="cookie__format--bold">By using our websites, we assume you consent to our use of cookies.</div><p>Providing services via our websites means that we sometimes need to place small amounts of information on your device. This information is stored in small text files that are known as cookies. Most websites do this to improve how they work and respond to you, for example:</p><ul><li>remembering settings, so you don’t have to keep re-entering them on each new page</li><li>remembering information you’ve given, so you don’t need to keep entering it</li><li>measuring how you use the website, so we can make sure it meets your needs</li></ul><p>Our cookies aren’t used to identify you personally. They just make the site work better for you. You can manage and/or delete these small files as you wish.</p><p>To learn more about cookies and how to manage them, visit the <a class="cc-link" href="https://www.aboutcookies.org.uk/">About Cookies website</a>.</p></div>'
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of our website. Without these cookies, the website would not work properly',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        }, {
                            title: 'Performance and Analytics',
                            description: 'These cookies allow the website to remember the choices you have made in the past',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_ga',       // match all cookies starting with "_ga"
                                    col2: '2 years',
                                    col3: 'Used to distinguish users.',
                                    is_regex: true
                                },
                                {
                                    col1: '_gid',
                                    col2: '24 hours',
                                    col3: 'Used to distinguish users.',
                                },
                                {
                                    col1: '_ga_&lt;container-id&gt',
                                    col2: '2 years',
                                    col3: 'Used to persist session state.',
                                },
                                {
                                    col1: '_gac_gb_&lt;container-id&gt',
                                    col2: '90 days',
                                    col3: 'Contains campaign related information. If you have linked your Google Analytics and Google Ads accounts, Google Ads website conversion tags will read this cookie unless you opt-out. <a class="cc-link" href="https://support.google.com/google-ads/answer/7521212">Learn more.</a>',
                                }
                            ]
                        }, {
                            title: 'Advertising Cookies',
                            description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data cannot be used to identify you.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            }
                        }, {
                            title: 'More information',
                            description: 'The Enterprising Barnsley website is the property of Barnsley Council. Please visit <a class="cc-link" href="https://www.barnsley.gov.uk/services/accessibility/how-we-use-cookies/">Barnsley Council’s Cookie Policy page</a> to find out more about our cookie policy usage. You can also read more on their <a class="cc-link" href="https://www.barnsley.gov.uk/services/information-and-privacy/your-privacy/">Privacy Policy page</a> too.',
                        }
                    ]
                }
            }
        }
    });

});
